export default (state = false, action) => {
  switch (action.type) {
    case 'FETCH_SUGGEST_PRODUCT':
      return { ...state, ...action.payload } || false
    default:
      return state
  }
}